import { render, staticRenderFns } from "./ChildsBySexChart.vue?vue&type=template&id=2f1f6172&scoped=true"
import script from "./ChildsBySexChart.vue?vue&type=script&lang=js"
export * from "./ChildsBySexChart.vue?vue&type=script&lang=js"
import style0 from "./ChildsBySexChart.vue?vue&type=style&index=0&id=2f1f6172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f6172",
  null
  
)

export default component.exports